import { getCountries } from "libphonenumber-js";
import * as yup from "yup";

const phoneSchema = yup.object({
  countryCode: yup
    .string()
    .min(1, "Selecciona un código de país.")
    .oneOf(getCountries())
    .required(""),
  number: yup
    .string()
    .min(7, "El número de teléfono debe tener entre 7 y 15 dígitos.")
    .max(15, "El número de teléfono debe tener entre 7 y 15 dígitos.")
    .required("Ingrese un número de teléfono"),
});

export default phoneSchema;
